module.exports = __webpack_public_path__ + "img/image8.3f14d441.png";